export const filterGroupFields = [
    {
        name: "name",
        label: "Filter Group Name",
        type: "text",
        required: true
    }
];


export const filterFields = [
    {
        name: "name",
        label: "Filter Name",
        type: "text",
        required: true
    },
    {
        name: "image",
        label: "Filter Image",
        type: "file",
        required: true,
        upload: "cloudinary" // optional flag
    }
];

export const collectionPartnerFields = [
    {
        name: "name",
        label: "Partner Name",
        type: "text",
        required: true
    },
    {
        name: "logo",
        label: "Partner Logo",
        type: "file",
        required: true,
        upload: "cloudinary" // optional flag
    }
]

export const colorFields = [
    {
        name: "name",
        label: "Color Name",
        type: "text",
        required: true
    },
    {
        name: "code",
        label: "Color Code (hex)",
        type: "text",
        required: true
    },
    {
        name: "family",
        label: "Color Family",
        type: "select",
        required: true,
        optionsKey: "masterColors"
    }
];

export const rawMaterialCategoryField = [
    {
        name: "name",
        label: "Category Name",
        type: "text",
        required: true
    },
    {
        name: "type",
        label: "Raw Material Type",
        type: "select",
        required: true,
        optionsKey: 'categories'
    }
]

export const rawMaterialVendorField = [
    {
        name: "name",
        label: "Venor Name",
        type: "text",
        required: true
    },
    {
        name: "category",
        label: "Raw Material Category",
        type: "select",
        required: true,
        optionsKey: "categories"
    }
]

export const blogCategoryFields = [
    {
        name: "name",
        label: "Category Name",
        type: "text",
        required: true
    }
];